<template>
  <div class="card">
    <div class="card-body">
      <h4>{{ "billing_contact" | t }}</h4>
      <hr />
      <div
        v-for="(value, key) in billingContactInfo"
        :key="key"
        class="mb-2 row"
      >
        <div class="col-md-4">
          <strong>{{ key | t }}</strong>
        </div>
        <div class="col-md-8">{{ value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: Object,
  },
  computed: {
    billingContactInfo() {
      return {
        name: this.customer.billing_contact_name,
        phone: this.customer.billing_contact_phone,
        email: this.customer.billing_contact_email,
      };
    },
  },
};
</script>